import { Input } from 'antd';
import useAntSearch from './useAntSearch';


const AntSearch = ({placeholder,getData}) => {

const { onChange} = useAntSearch({getData})

return(


<Input 
  placeholder={placeholder || ''}
  onChange={onChange}
  size='large'
  style={{ width: '100%' }}/>

)}
 export default AntSearch;